import { requestResourceByName, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import DeleteMessagesButton from '../../../components/_DeleteMessagesButton';
import { SecuredMessagingState } from '../../../interfaces/SecuredMessagingState';

export interface DeleteButtonProps {
  messageSource: string;
}

const DeleteButton: FC<DeleteButtonProps> = ({ messageSource }) => {
  const { t } = useTranslation('SecureMessagingPage');
  const dispatch = useDispatch();
  const messages = useScopedSelector((state: SecuredMessagingState) => state.messages?.data);
  const selectedMessages: number[] = useScopedSelector((state: SecuredMessagingState) => state.selectedMessages);

  if (!messages) {
    return null;
  }

  const messageIds = messages.filter((message) => selectedMessages?.includes(message.id)).map((x) => x.id);
  const successMessage: string = messageIds.length > 1 ? t('messagesDeletedSnackbar_many', { count: messageIds.length }) : t('messagesDeletedSnackbar_one');

  const handleSuccess = () => {
    dispatch(requestResourceByName(`messagesResource${messageSource}`));
  };

  return (
    <DeleteMessagesButton
      messageSource={messageSource}
      messageIds={messageIds}
      handleSuccess={handleSuccess}
      successMessage={successMessage}
    />
  );
};
export default DeleteButton;
